import { AxiosRequestConfig, AxiosResponse } from "axios";
import { AppDispatch, AppGetState } from "../store";
import { IBwaIoGateway } from "../io/ioGateway";
import { getGlobalLevelToken } from "./accessTokenManagerActions";
import { makeSimpleId } from "../utils";
import { error, log } from "./modules/logger/actions";
import {
  EVENT_HTTP_REQUEST_FAILED,
  EVENT_HTTP_REQUEST_SENT,
  EVENT_HTTP_REQUEST_SUCCEEDED,
} from "./modules/logger/constants";

export const globalContextRequest = (
  axiosRequestConfig: AxiosRequestConfig,
) => async (
  dispatch: AppDispatch,
  getState: AppGetState,
  { axios }: IBwaIoGateway,
): Promise<AxiosResponse> => {
  const accessToken = await dispatch(getGlobalLevelToken());
  const reqId = `request_${makeSimpleId()}`;
  const { method, url, data } = axiosRequestConfig;
  dispatch(
    log(
      EVENT_HTTP_REQUEST_SENT,
      "1",
      `${reqId} [...${accessToken.slice(
        -10,
      )}] ${method} ${url} ${JSON.stringify(data)}`,
    ),
  );
  return axios({
    ...axiosRequestConfig,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
    .then(resp => {
      dispatch(log(EVENT_HTTP_REQUEST_SUCCEEDED, "1", reqId));
      return resp;
    })
    .catch(err => {
      dispatch(
        error(EVENT_HTTP_REQUEST_FAILED, "1", `${reqId} ${err.message}`),
      );
      throw err;
    });
};
